import type { ReactNode } from 'react'

/** Small-caps caption above a form control or block. */
export function Caption({ children }: { children: ReactNode }) {
  return <div className="text-[11px] font-medium uppercase tracking-[0.07em] text-text-3">{children}</div>
}
